var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-text-align-center u-padding-top u-padding-bottom"},[_c('img',{staticClass:"u-no-found-image",attrs:{"src":_vm.noFoundImage,"alt":_vm.$t('noFoundData')}}),_c('div',[_c('small',{staticClass:"u-font-size-xsmall"},[_c('i',[_vm._v(_vm._s(_vm.$t("noFoundData")))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }